import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import PlayerPage from "@/pages/PlayerPage";
import LoginPage from "@/pages/LoginPage";
import AdminPage from "@/pages/AdminPage";
import EmbedPlayer from "@/pages/EmbedPlayer";

function ProtectedAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-[var(--text-muted)] font-mono text-sm">Authenticating...</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App app-bg">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<PlayerPage />} />
            <Route path="/embed" element={<EmbedPlayer />} />
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin" element={<ProtectedAdmin><AdminPage /></ProtectedAdmin>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
